import dayjs from 'dayjs';

import { PayslipMonthResponse } from '../types/types';
import { PayslipUser, ValidatePayslipPayload } from '../types/types';
import { MS_PAYSLIP_ENDPOINT } from '../variables/GlobalVariables';
import request from './AxiosClient';

function getUserPayslip(
  userId: string | undefined,
  year: number,
  month: number,
  companyId: string
): string {
  return `${MS_PAYSLIP_ENDPOINT}/v2/payslip/user/${userId}/attachment/${year}/${month}?companyId=${companyId}`;
}

function getPayslipsMonthInfo(
  companyId: string,
  month: number,
  year: number
): Promise<PayslipMonthResponse> {
  return request
    .get(
      `${MS_PAYSLIP_ENDPOINT}/v2/payslip/month/${companyId}/${month}/${year}`
    )
    .then((res) => res?.data);
}

function getUserPayslips(
  userId: string | undefined,
  tmp: boolean
): Promise<PayslipUser[]> {
  return request
    .get(`${MS_PAYSLIP_ENDPOINT}/v2/payslip/user/${userId}/list?tmp=${tmp}`)
    .then((res) => {
      return res?.data.sort(
        (a: PayslipUser, b: PayslipUser) =>
          dayjs(`15/${b.month}/${b.year}`, 'D/M/YYYY').valueOf() -
          dayjs(`15/${a.month}/${a.year}`, 'D/M/YYYY').valueOf()
      );
    });
}

function getUserPayslipMonth(
  userId: string,
  year: number,
  month: number,
  companyId: string | undefined,
  accessToken?: string,
  refreshToken?: string
): string {
  let path = `${MS_PAYSLIP_ENDPOINT}/v2/payslip/month/${userId}/attachment/${year}/${month}?companyId=${companyId}`;
  if (accessToken && refreshToken) {
    path += '&accessToken=' + accessToken + '&refreshToken=' + refreshToken;
  }
  return path;
}

function reassignPayslip(
  oldUserId: string,
  userId: string,
  year: number,
  month: number
) {
  return request
    .patch(
      `${MS_PAYSLIP_ENDPOINT}/v2/payslip/month/${oldUserId}/${userId}/updatePayslip/${year}/${month}`
    )
    .then((res) => res?.data);
}

function unassignPayslip(userId: string, year: number, month: number) {
  return request
    .patch(
      `${MS_PAYSLIP_ENDPOINT}/v2/payslip/month/${userId}/unassignPayslip/${year}/${month}`
    )
    .then((res) => res?.data);
}

function removeUserPayslip(
  companyId: string,
  tmpUserId: string,
  month: number,
  year: number
) {
  return request
    .delete(
      `${MS_PAYSLIP_ENDPOINT}/v2/payslip/month/${companyId}/${tmpUserId}/${month}/${year}`
    )
    .then((res) => res?.data);
}

function downloadPayslipSourceFile(
  payslipMonthId: string,
  sourceKey: number,
  companyId: string
): string {
  return `${MS_PAYSLIP_ENDPOINT}/v2/payslip/source/${companyId}/${payslipMonthId}/${sourceKey}`;
}

function validateAndNotifyPayslips(
  companyId: string,
  month: number,
  year: number,
  payload: ValidatePayslipPayload,
  collaborator_access_token?: string,
  collaborator_refresh_token?: string
): Promise<any> {
  if (collaborator_access_token && collaborator_refresh_token) {
    return request
      .patch(
        `${MS_PAYSLIP_ENDPOINT}/v2/payslip/month/validate/${companyId}/${month}/${year}?accessToken=${collaborator_access_token}&refreshToken=${collaborator_refresh_token}`,
        payload
      )
      .then((res) => res?.data);
  } else {
    return request
      .patch(
        `${MS_PAYSLIP_ENDPOINT}/v2/payslip/month/validate/${companyId}/${month}/${year}`,
        payload
      )
      .then((res) => res?.data);
  }
}

const PayslipService = {
  getUserPayslip,
  getUserPayslips,
  getPayslipsMonthInfo,
  getUserPayslipMonth,
  validateAndNotifyPayslips,
  reassignPayslip,
  unassignPayslip,
  removeUserPayslip,
  downloadPayslipSourceFile,
};

export default PayslipService;
